<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :class="size"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      :fill="color"
      stroke="none"
    >
      <path
        d="M2535 4953 c-519 -47 -995 -245 -1380 -575 -393 -337 -668 -797 -777
-1300 -13 -60 -25 -108 -28 -108 -3 1 -21 24 -40 52 -51 75 -80 93 -150 93
-97 0 -155 -58 -155 -154 l0 -58 175 -262 c96 -145 187 -273 202 -287 34 -28
84 -39 136 -29 32 6 71 40 274 243 255 256 260 262 243 349 -9 49 -69 109
-118 118 -69 13 -105 -1 -179 -72 -41 -40 -68 -60 -68 -51 0 35 70 289 105
383 310 830 1139 1379 2025 1342 1044 -45 1874 -825 1990 -1872 30 -270 -7
-588 -99 -865 -260 -777 -948 -1325 -1770 -1409 -697 -72 -1355 202 -1786 744
-51 63 -89 102 -111 111 -121 50 -244 -51 -220 -180 13 -67 213 -301 381 -446
241 -206 498 -352 788 -445 226 -74 395 -103 642 -112 536 -19 1032 123 1462
419 373 256 668 614 842 1020 239 557 265 1147 75 1717 -302 906 -1105 1542
-2059 1631 -103 9 -311 11 -400 3z"
      />
      <path
        d="M2575 4066 c-37 -17 -70 -52 -84 -89 -8 -19 -11 -271 -11 -777 0
-661 2 -754 16 -789 14 -35 74 -83 527 -423 l510 -383 58 0 c65 0 98 18 137
75 28 42 30 112 2 157 -22 37 -5 23 -530 421 l-395 299 -5 711 c-5 698 -5 711
-26 738 -11 15 -32 37 -46 47 -34 25 -113 32 -153 13z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: "w-5 h-5",
    },
    color: {
      type: String,
      default: "#1F2937",
    },
  },
};
</script>

<style></style>
